import Api from "./Api";

const endpoint = "/fibu/category";
export default {
    get(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint, usedParams);
    },
    getSingle(id, params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint + "/" + id, usedParams);
    },
    put(id, data) {
        return Api.putData(endpoint + "/" + id, data);
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    delete(id) {
        return Api.deleteData(endpoint + "/" + id);
    }
};
